import { createTheme } from '@mui/material';

const customColors = {
  DarkGreen: '#294626',
  Green: '#65AC5D',
  Orange: '#ca9e31',

  $TCPG900: '#131b12',
  $TCPG500: '#294626',
  $TCPG450: '#10592e',
  $TCPG400: '#65ac5d',
  $TCPG300: '#f8f6ef',
  $TCPG200: '#effaed',

  $TCPB900: '#151414',
  $TCPB800: '#242424',
  $TCPB500: '#666565',
  $TCPB100: '#eaeaea',

  $TCPYL500: '#ca9e31',
  $TPCOR500: '#d46527',
};
// MUI Theme Declaration
declare module '@mui/material/styles' {
  interface Palette {
    $TCPG900: string;
    $TCPG500: string;
    $TCPG450: string;
    $TCPG400: string;
    $TCPG300: string;
    $TCPG200: string;

    $TCPB900: string;
    $TCPB800: string;
    $TCPB500: string;
    $TCPB100: string;

    $TCPYL500: string;
    $TPCOR500: string;
  }
}

const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },
  palette: {
    ...customColors,
    primary: {
      dark: customColors.$TCPG400,
      main: customColors.$TCPG300,
      light: customColors.$TCPG200,
    },
    secondary: {
      dark: customColors.$TCPG900,
      main: customColors.$TCPG500,
      light: customColors.$TCPG450,
    },
    info: {
      dark: customColors.$TCPG900,
      main: customColors.$TCPG500,
      light: customColors.$TCPG450,
    },
  },
});

export default theme;
